import Partner_1 from "../assets/imgg-royal-caribean.jpg";
import Partner_2 from "../assets/imgg-celebrity-cruises-1.jpg";
import Partner_3 from "../assets/silversea-cruises.jpg";
import Partner_4 from "../assets/imgg-azmara.jpg";


const Pdata = [
    {
        img:Partner_1,
        partner:"Royal Caribbean"
    },
    {
        img:Partner_2,
        partner:"Celebrity Cruises"
    },
    {
        img:Partner_3,
        partner:"Silversea"
    },
    {
        img:Partner_4,
        partner:"Azamara Cruises"
    }
    
]

export default Pdata ;